import { render, staticRenderFns } from "./OnDemand.vue?vue&type=template&id=56c774dc"
import script from "./OnDemand.vue?vue&type=script&lang=js"
export * from "./OnDemand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports